import { render, staticRenderFns } from "./TotalBuildableGroundFloorSurface.vue?vue&type=template&id=db5e2bd0&"
import script from "./TotalBuildableGroundFloorSurface.vue?vue&type=script&lang=ts&"
export * from "./TotalBuildableGroundFloorSurface.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports